/**
 *
 * Modal
 *
 */

import React from "react";
import { Title, TitleWrapper, Content, Button } from "./styledComponents";
import StyledModal from "./StyledModal";

import Icon from "components/Icon";

const Modal = ({
  close,
  children,
  title,
  shakeOnOpen,
  dismissable = true,
  tinyModal = false,
}) => (
  <StyledModal
    onRequestClose={close}
    isOpen={true}
    overlayClassName="modal__overlay"
    shakeOnOpen={shakeOnOpen}
    shouldCloseOnOverlayClick={true}
    contentLabel={title}
  >
    {dismissable ? (
      <Button onClick={() => close()}>
        <Icon name="close" size="12" />
      </Button>
    ) : null}
    <TitleWrapper>
      <Title>{title}</Title>
    </TitleWrapper>
    <Content tinyModal={tinyModal}>{children}</Content>
  </StyledModal>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js